import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  FaFacebook, 
  FaInstagram, 
  FaLinkedin, 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaApple,
  FaGooglePlay
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/pasa_lebensmittel_white_logo.png" alt="Paşa Lebensmittel" />
            </div>
            <p className="footer-description">{t('footer.description')}</p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>{t('footer.company')}</h4>
            <ul>
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/about">{t('nav.about')}</Link></li>
              <li><Link to="/products">{t('nav.products')}</Link></li>
              <li><Link to="/contact">{t('nav.contact')}</Link></li>
              <li><Link to="/impressum">{t('footer.impressum')}</Link></li>
              <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms">{t('footer.terms')}</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('contact.info.title')}</h4>
            <ul className="contact-info">
              <li>
                <FaPhone />
                <span>+49 40 32527151</span>
              </li>
              <li>
                <FaEnvelope />
                <span>info@pasalebensmittel.com</span>
              </li>
              <li>
                <FaMapMarkerAlt />
                <span>Hamburg, Deutschland</span>
              </li>
            </ul>
          </div>

          <div className="footer-section mobile-app-section">
            <h4>{t('nav.b2b')}</h4>
            <p className="app-description">
              {t('hero.description')}
            </p>
            <div className="app-buttons">
              <a 
                href="https://apps.apple.com/tr/app/pasa-lebensmittel-mobile/id6449462744" 
                target="_blank" 
                rel="noopener noreferrer"
                className="app-button apple"
              >
                <FaApple className="app-icon" />
                <div className="app-text">
                  <span className="download-text">{t('footer.downloadOn')}</span>
                  <span className="store-text">{t('footer.appStore')}</span>
                </div>
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=de.pasalebensmittel.mobile&hl=tr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="app-button google"
              >
                <FaGooglePlay className="app-icon" />
                <div className="app-text">
                  <span className="download-text">{t('footer.getItOn')}</span>
                  <span className="store-text">{t('footer.googlePlay')}</span>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Paşa Lebensmittel. {t('footer.rights')}</p>
          <p className="developer-credit"><a href="https://www.boranka.com" target="_blank" rel="noopener noreferrer">
          <img src="/design-by-boranka.png" alt="Boranka Teknoloji" height={20}/>
          </a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

